var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"item",attrs:{"href":_vm.url},on:{"click":function($event){$event.preventDefault();_vm.go($event)}}},[_c('span',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.icon('email'))}}),_vm._v("\n\tSubscribe\n")])}
var staticRenderFns = []

export { render, staticRenderFns }